import { createContext } from "react";

const DF_CO0004Context = createContext();

export { DF_CO0004Context };
